import styled, { keyframes, css } from 'styled-components'

const slide = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`

export const Slider = styled.div`
  align-content: center;
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  padding-block: 1.3rem;
  cursor: pointer;
`

export const SliderTrack = styled.div<{ isPaused: boolean }>`
  display: flex;
  gap: 15px;
  width: max-content;
  animation: ${slide} 20s linear infinite;
  animation-play-state: ${({ isPaused }) => (isPaused ? 'paused' : 'running')};
  flex-wrap: nowrap;
`
export const Logo = styled.img<{ width?: string; height?: string }>`
  width: ${({ width }) => width || '140px'};
  height: ${({ height }) => height || '67px'};
  flex-shrink: 0;
`
